import * as React from 'react';
import type { SVGProps } from 'react';
const SvgLogoOffice365 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 178 46'
    {...props}
  >
    <mask
      id='Logo_Office_365_svg__a'
      width={170}
      height={38}
      x={4}
      y={4}
      maskUnits='userSpaceOnUse'
      style={{
        maskType: 'luminance',
      }}
    >
      <path fill='#fff' d='M4 4h170v37.4H4z' />
    </mask>
    <g mask='url(#Logo_Office_365_svg__a)'>
      <path
        fill='#C75B12'
        d='M69.815 22.819q0 3.201-1.166 5.61-1.168 2.41-3.354 3.71t-5.037 1.3q-2.753 0-4.898-1.264t-3.318-3.592q-1.174-2.325-1.174-5.274 0-3.173 1.188-5.59 1.186-2.415 3.409-3.709 2.221-1.293 5.141-1.293 2.67 0 4.788 1.271 2.115 1.273 3.268 3.577t1.153 5.254m-2.459.308q0-3.914-1.83-6.107-1.832-2.192-5.1-2.193-2.055.001-3.683 1.04-1.626 1.042-2.522 2.957-.894 1.915-.894 4.275 0 2.403.86 4.284.859 1.877 2.451 2.906 1.594 1.027 3.62 1.028 3.324 0 5.212-2.18 1.886-2.183 1.886-6.01m12.533-9.208q-.67-.379-1.524-.378-2.403 0-2.403 3.034v2.207h3.353v1.94h-3.353V33.09H73.67V20.722h-2.43v-1.94h2.43v-2.32q0-2.182 1.285-3.521 1.288-1.342 3.271-1.342 1.047 0 1.663.252z'
      />
    </g>
    <mask
      id='Logo_Office_365_svg__b'
      width={170}
      height={38}
      x={4}
      y={4}
      maskUnits='userSpaceOnUse'
      style={{
        maskType: 'luminance',
      }}
    >
      <path fill='#fff' d='M4 4h170v37.4H4z' />
    </mask>
    <g mask='url(#Logo_Office_365_svg__b)'>
      <path
        fill='#C75B12'
        d='M87.787 13.918q-.671-.378-1.524-.377-2.403 0-2.403 3.033v2.207h3.354v1.941H83.86V33.09h-2.292V20.722h-2.432V18.78h2.432v-2.32q0-2.181 1.285-3.52 1.287-1.344 3.27-1.343 1.049 0 1.663.253zm4.225-.265q0 .643-.447 1.067a1.48 1.48 0 0 1-1.061.426q-.63 0-1.063-.411-.433-.413-.433-1.083 0-.601.426-1.04.427-.441 1.069-.44.642-.002 1.076.432.434.431.434 1.049m-.39 19.434h-2.293V18.78h2.292zm13.078-.655q-1.663 1.006-3.927 1.006-1.955 0-3.514-.9-1.559-.902-2.424-2.552-.867-1.648-.866-3.702 0-3.548 2.032-5.702 2.033-2.152 5.415-2.152 1.873 0 3.312.727v2.347q-1.607-1.117-3.409-1.117-2.222.001-3.612 1.586t-1.391 4.101q0 2.502 1.321 3.955 1.32 1.452 3.542 1.452 1.872 0 3.521-1.23zm14.08-5.924h-10.103q.057 2.417 1.28 3.696 1.221 1.276 3.386 1.277 2.432.001 4.432-1.564v2.139q-1.873 1.382-4.975 1.382-3.061 0-4.78-1.977-1.718-1.977-1.719-5.471 0-2.124.861-3.877.86-1.752 2.367-2.717a6.1 6.1 0 0 1 3.353-.966q2.78 0 4.339 1.811 1.56 1.808 1.559 5.065zm-2.347-1.943q-.028-1.983-.958-3.082-.929-1.097-2.619-1.097-1.594 0-2.724 1.146-1.133 1.145-1.425 3.032zm19.783 2.85q0 2.711-1.942 4.367-1.944 1.656-5.101 1.656-2.864 0-4.556-1.09v-2.46q2.028 1.593 4.638 1.593 2.111 0 3.362-1.041 1.252-1.04 1.252-2.816-.001-3.925-5.59-3.925h-1.662v-1.944h1.578q4.946 0 4.947-3.689 0-3.408-3.774-3.408-2.123 0-3.981 1.425V13.86q1.913-1.145 4.555-1.146 2.487 0 4.017 1.322 1.53 1.32 1.529 3.457 0 3.955-3.996 5.087v.055q2.124.237 3.425 1.538 1.299 1.3 1.299 3.241m15.075-.684q0 1.901-.817 3.451-.815 1.551-2.257 2.403-1.439.854-3.227.853-3.003 0-4.717-2.417-1.711-2.416-1.711-6.75 0-3.436 1.014-6.07 1.013-2.634 2.87-4.058 1.86-1.427 4.29-1.426 2.068 0 3.327.573v2.166a7.07 7.07 0 0 0-3.271-.796q-2.654 0-4.254 2.383-1.602 2.382-1.601 6.35h.056q1.384-2.837 4.569-2.837 2.6 0 4.165 1.698 1.565 1.695 1.564 4.477m-2.346.293q-.001-2.096-1.027-3.312-1.027-1.214-2.872-1.213-1.675-.001-2.823 1.18c-.764.785-1.144 1.74-1.144 2.856q0 2.111 1.138 3.528 1.139 1.419 2.872 1.418 1.718.001 2.787-1.237t1.069-3.22m15.831-.056q0 2.92-1.934 4.696-1.937 1.773-5.164 1.772-2.796 0-4.15-.837v-2.432q2.039 1.316 4.177 1.315 2.124 0 3.423-1.189 1.301-1.188 1.301-3.183-.002-1.958-1.313-3.069-1.315-1.11-3.815-1.11-1.999 0-3.396.166l.684-10.046h9.265v2.068h-7.28l-.405 5.883 1.844-.072q3.13.002 4.947 1.581 1.816 1.58 1.816 4.457M40.758 36.977l-.003-.002V9.208l-9.949-2.871-17.885 6.716-.045.008.002 20.078 6.104-2.389V14.415l11.824-2.827-.002 24.018-17.916-2.467 17.916 6.616v.007l9.95-2.754v-.031z'
      />
    </g>
  </svg>
);
export default SvgLogoOffice365;
